<div class="loader-container">
  <div class="overlay"></div>
  <div class="spinner">
    <div class="spinner-border text-danger" role="status">
      <span class="sr-only">Chargement...</span>
    </div>
  </div>
</div>
